import { makeAutoObservable } from "mobx";
import authStore from "../stores/AuthStore";

class WebSocketHandler {
  socket = null;
  isConnected = false;
  listeners = new Set();
  url =
    process.env.REACT_APP_WS_URL || "ws://localhost:8000/ws/mysql-log-stream";

  constructor() {
    makeAutoObservable(this);
  }

  connect() {
    if (this.isConnected || this.socket) return;

    const currentUser = authStore.getUser();
    const userID = currentUser?.id || currentUser?.userID;
    const wsUrl = userID ? `${this.url}?userID=${userID}` : this.url;

    console.log("🌐 Connecting to WebSocket at", wsUrl);
    this.socket = new WebSocket(wsUrl);

    this.socket.onopen = () => {
      console.log("✅ WebSocket connected");
      this.isConnected = true;
      this.send({ action: "subscribe", devices: "*" });
    };

    this.socket.onclose = () => {
      console.warn("❌ WebSocket disconnected");
      this.isConnected = false;
      this.socket = null;
    };

    this.socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    this.socket.onmessage = (message) => {
      // console.log("📨 Raw WebSocket message:", message.data);
      try {
        const data = JSON.parse(message.data);
        console.log("✅ Parsed WebSocket data:", data);
        this.listeners.forEach((cb) => cb(data));
      } catch (err) {
        console.warn("Failed to parse WebSocket message:", message.data);
      }
    };
  }

  disconnect() {
    if (this.socket) {
      console.log("🔌 Closing WebSocket...");
      this.socket.close();
      this.socket = null;
      this.isConnected = false;
    }
  }

  send(data) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.warn("WebSocket not open. Message not sent:", data);
    }
  }

  subscribe(callback) {
    this.listeners.add(callback);
  }

  unsubscribe(callback) {
    this.listeners.delete(callback);
  }

  requestLatestLogs() {
    this.send({ action: "get_latest_logs" });
  }
}

const webSocketHandler = new WebSocketHandler();
export default webSocketHandler;
